/***********************************************
* CutTool.js
* 
* Cuts a part of the pointcloud
***********************************************/
/* Layout files */
import '../../assets/style/Tools.css';

/* Global imports */
import React from 'react';
import { withTranslation } from 'react-i18next';

/* Local imports */
import CutTool from "./CutTool";
import VolumeTool from './VolumeTool';

function Tools(props) {

    return (
        <div className='tools'>
            <CutTool id={props.id}/>
            <VolumeTool id={props.id}/>
        </div>
    );
}

export default  withTranslation("Projects")(Tools);